import React from "react"
import { InputTextMaster, MasterButton, Modal } from "App/Component/ui"
import { Grid } from "@material-ui/core"

const ModalUbahScale = ({ setShowModal, scaleValue, handleChangeScale, loadingPrint, handleClickPrintPdf, loadingPrintv2, handleClickPrintPdfV2 }) => {
  return (
    <Modal title={"Ubah Skala Cetak"} show={setShowModal} width="20%">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <InputTextMaster
            name="scale"
            label="Skala Cetak (contoh: 0.89)"
            id="scale"
            placeholder="Skala Cetak"
            value={scaleValue}
            type="number"
            min={0.1}
            onChange={(e) => {handleChangeScale(e.target.value)}}
          />
        </Grid>
        <Grid item xs={12}>
          <div
            style={{
              display: "flex",
              gap: "10px",
            }}
          >
          <MasterButton
            type="button"
            color={loadingPrint ? "secondary" : "warning"}
            name={loadingPrint ? "Loading.." : "CETAK PDF"}
            onClick={() => {handleClickPrintPdf(); setShowModal(false)}}
            size="md"
          />

          <MasterButton
            type="button"
            color={loadingPrintv2 ? "secondary" : "warning"}
            name={loadingPrintv2 ? "Loading.." : "CETAK PDF V2"}
            onClick={() => {handleClickPrintPdfV2(); setShowModal(false)}}
            size="md"
          />
          </div>
        </Grid>
      </Grid>
    </Modal>
  )
}

export default ModalUbahScale
